const users = {
  User: {
    Label: 'کاربر',
    Id: 'شماره کاربری ',
    Profile: 'پروفایل کاربر',
    Name: 'نام و نام خانوادگی',
    Username: 'نام‌کاربری',
    MobileNumber: 'شماره همراه',
    Email: 'ایمیل',
    Role: 'سطح کاربری',
    Info: 'اطلاعات کاربری',
    Serial: 'سریال',
    Udid: 'udid',
    Imei: 'imei',
    IsDefault: 'پیشفرض بودن',
    DeleteDevice: 'حذف دستگاه',
    SeeUser: 'مشاهده کاربر',
    AccountType: 'نوع اکانت',
    NationalId: 'شناسه‌ملی',
    Tel: 'تلفن',
    Address: 'آدرس',
    PostalCode: 'کدپستی',
    EconomicCode: 'کداقتصادی',
    NationalCardImage: 'کارت‌ملی',
    CompanyImage: 'ثبت',
    PendingStatus: 'در انتظار تایید',
    RejectedStatus: 'رد شده',
    ConfirmedStatus: 'تایید شده',
    status: 'وضعیت',
    AuthenticationUsers: 'احراز هویت توسعه دهندگان',
    RejectReson: 'دلیل رد',
    UpgradeToAdmin: 'ارتقا به ادمین',
    ActivatePassword: 'فعال سازی رمز پنل توسعه دهنده',
    UpgradeTitle: 'ارتقا کاربر {name} به ادمین',
    Password: {
      Change: 'تغییر کلمه عبور',
    },
    ActivePackage: {
      Tooltip: 'فعال کردن پکیج',
      Title: 'فعال کردن پکیج',
      SelectPackage: 'پکیج را انتخاب کنید',
    },
    Packages: {
      ExpandDuration: 'افزایش بازه پکیج',
      MoneyBack: {
        Title: 'نوع برگشت پول',
        Wallet: 'کیف پول',
        Bank: 'حساب بانکی',
        ExpirePackage: 'پکیج غیر فعال شود',
        Tooltip: 'برگشت پول پکیج',
        MoneyAmount: 'مقدار بازگشت پول',
        ModalTitle: 'غیر فعال کردن پکیج و برگشت پول',
      },
    },
    Transfer: {
      Login: 'انتقال به حساب توسعه دهنده ',
    },
  },
}

export default users
